import { isVisible } from "../../helpers/dom";
export const header = {
    applyStylesForHeaderNav: function () {
        const navigation = document.querySelector(".c-header");
        const body = document.querySelector(".l-body");
        const isScrollTop = window.scrollY === 0;
        const isNavFixed = navigation === null || navigation === void 0 ? void 0 : navigation.classList.contains("c-header--fixed");
        const isNavNotFixed = navigation === null || navigation === void 0 ? void 0 : navigation.classList.contains("c-header--not-fixed");
        const isSearchResultsDisplayed = Boolean(document.querySelectorAll(".js-wide-result").length);
        if (!isNavFixed && !isNavNotFixed) {
            return;
        }
        if (isNavFixed && !isSearchResultsDisplayed) {
            body.classList.toggle("l-body--fixed", isScrollTop);
        }
        if (isNavNotFixed) {
            body.classList.toggle("l-body--not-fixed", isScrollTop);
        }
    },
    handleSearchPosition: function () {
        const headerSearchWrapper = document.querySelector(".c-header_search-wrapper");
        const autoSuggestSearchResultWrapper = document.querySelector(".c-autosuggest-search-result_wrapper");
        const whiteLogo = document.querySelector(".c-top-nav_logo-img--white");
        const isWhiteLogoVis = isVisible(whiteLogo);
        headerSearchWrapper === null || headerSearchWrapper === void 0 ? void 0 : headerSearchWrapper.classList.toggle("c-header_search-wrapper--low", isWhiteLogoVis);
        autoSuggestSearchResultWrapper === null || autoSuggestSearchResultWrapper === void 0 ? void 0 : autoSuggestSearchResultWrapper.classList.toggle("c-autosuggest-search-result_wrapper--low", isWhiteLogoVis);
    },
};
